import React from 'react';
import styled from 'styled-components';

const StyledInput = styled.input`
    flex: 1;
`;

const NUMBER_EXP = /^\d*$/;

class Input extends React.Component {
    static defaultProps = {
        type: 'text'
    };

    onChange = ({ target }) => {
        const { field, model, type } = this.props;
        if (type === 'number' && !target.value.match(NUMBER_EXP)) {
            return;
        }

        this.props.onChange({ ...model, [field]: target.value });
    };

    render() {
        const { field, model, style, type, ...props } = this.props;
        let styles = {
            ...style
        };
        if (type === 'number') {
            styles = {
                ...style,
                maxWidth: 100
            };
        }
        return (
            <StyledInput
                {...props}
                style={styles}
                value={model[field]}
                onChange={this.onChange}
            />
        );
    }
}

export default Input;



// WEBPACK FOOTER //
// ./src/pages/Relay/Input.js